import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/home.js';
import About from './pages/about.js';
import NotFound from "./pages/notFound.js";
import './App.css';
import Hire from "./pages/hire.js";
import HappyBirthday from "./pages/happybirthday.js";
import CreateBirthdayCard from "./pages/createbirthdaycard.js";
//import TodoPage from "./pages/TodoList.js";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/hire" element={<Hire />} />
        <Route path='/birthday' element={<HappyBirthday />} />
        <Route path='/create/birthday' element={<CreateBirthdayCard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
